<template>
    <div class="regular-list" ref="list">
        <div class="list-header">
            <CheckBox
                @input="selectAll"
                class="checkbox"
                v-if="selectList"
                v-model="selectedAll"
                :semi="isAnySelected"
            ></CheckBox>
            <div
                :class="{ '-hidden': headerElement.avatar }"
                :key="index"
                :style="{ flex: headerElement.size }"
                class="regular-list-cell -header"
                v-for="(headerElement, index) in filteredHeader"
            >
                <div
                    :class="{ '-sort': headerElement.sort }"
                    @click="toggleSort(headerElement.sort)"
                    class="cell-content"
                >
                    {{ headerElement.display }}
                    <div
                        class="regular-list-actions-header"
                        v-if="headerElement.type == 'more'"
                    >
                        <i class="material-icons">more_horiz</i>
                    </div>
                    <transition mode="out-in" name="fade">
                        <div
                            :class="{
                                '-rotated':
                                    sortDirection == 'up' &&
                                    headerElement.sort.key == currentSort.key,
                                '-active':
                                    headerElement.sort.key == currentSort.key
                            }"
                            class="sort-icon"
                            v-if="headerElement.sort"
                        >
                            <i class="material-icons">arrow_downward</i>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        <transition mode="out-in" name="fade">
            <ListPlaceholder
                :title="listPlaceholder"
                v-if="presenceDays.length == 0 && items.length == 0 && !loading"
            />
            <div
                class="loader"
                v-if="presenceDays.length == 0 && items.length == 0 && loading"
            >
                <div class="lottie-loader">
                    <lottie-animation path="lottie/dots.json" />
                </div>
            </div>
            <div
                class="list-content"
                v-if="
                    (presenceDays.length != 0 || items.length != 0) && !loading
                "
            >
                <transition-group name="list">
                    <RightClickMenu
                        :block="row.block"
                        :class="{
                            '-block-select': row.blockSelect || blockSelect,
                            '-selected': row.selected && !selectList
                        }"
                        :disabled="
                            row.blockSelect ||
                            blockSelect ||
                            (row.more && row.more.length > 0)
                        "
                        :key="row.key"
                        :menuContent="row.menu"
                        @action="emitAction"
                        class="regular-list-row"
                        v-for="row in items"
                    >
                        <div
                            class="checkbox-blocked"
                            v-if="selectList && row.done"
                        >
                            <i class="material-icons">check</i>
                        </div>
                        <CheckBox
                            @input="itemToggled"
                            class="checkbox"
                            v-if="selectList && !row.blocked && !row.done"
                            :value="row.selected"
                            v-model="row.selected"
                        ></CheckBox>
                        <CheckBox
                            class="checkbox -red"
                            v-if="selectList && row.blocked"
                        ></CheckBox>
                        <div class="icon" v-if="row.icon && !row.avatar">
                            <Emoji
                                :value="row.icon.url"
                                :type="row.icon.type"
                            />
                        </div>
                        <div class="avatar" v-if="row.avatar">
                            <img :src="row.avatar" />
                        </div>
                        <div
                            :class="{ '-red': cell.alert }"
                            :key="`cell${index}`"
                            :style="{ flex: cell.size }"
                            @click="itemSelected(cell, row)"
                            :id="cell.id"
                            class="regular-list-cell"
                            v-for="(cell, index) in row.cells"
                        >
                            <div
                                :class="[
                                    {
                                        '-color': cell.color,
                                        '-selected': row.selected && !selectList
                                    },
                                    `-${cell.textType}`
                                ]"
                                :style="{
                                    color: $Utils.colors[cell.color]
                                }"
                                class="regular-list-cell-text"
                                v-if="cell.type == 'text'"
                            >
                                {{ display(cell.display) }}
                                <div class="regular-list-cell-sub-text">
                                    {{ cell.subDisplay }}
                                </div>
                            </div>
                            <div
                                class="regular-list-cell-text"
                                v-if="cell.type == 'icon'"
                            >
                                <i
                                    class="material-icons"
                                    :style="{
                                        color: `${$Utils.colors[cell.color]}`
                                    }"
                                    >{{ cell.materialIcon }}</i
                                >
                            </div>
                            <div
                                v-if="cell.type == 'labels'"
                                style="display: flex;"
                            >
                                <div
                                    :style="{
                                        color: $Utils.colors[label.color]
                                    }"
                                    class="info-label"
                                    v-for="(label, index) in cell.content"
                                    :key="index"
                                >
                                    <div
                                        :style="{
                                            background: `${
                                                $Utils.colors[label.color]
                                            }`
                                        }"
                                        class="info-label-background"
                                    ></div>
                                    <div
                                        class="regular-list-cell-label-text"
                                        v-if="label.display"
                                    >
                                        {{ display(label.display) }}
                                    </div>
                                </div>
                            </div>
                            <div
                                :style="{
                                    color: $Utils.colors[cell.color]
                                }"
                                class="info-label"
                                v-if="cell.type == 'label'"
                            >
                                <div
                                    :style="{
                                        background: `${
                                            $Utils.colors[cell.color]
                                        }`
                                    }"
                                    class="info-label-background"
                                ></div>
                                <div
                                    class="regular-list-cell-label-text"
                                    v-if="cell.display"
                                >
                                    {{ display(cell.display) }}
                                </div>
                            </div>
                            <div class="icons" v-if="cell.type == 'icons'">
                                <div
                                    :key="`statusIcon${index}`"
                                    class="icon-wrap"
                                    v-for="(icon, index) in cell.icons"
                                >
                                    <span>{{ icon.hint }}</span>
                                    <img
                                        :src="require(`@/${icon.url}`)"
                                        v-if="icon.url"
                                    />
                                </div>
                            </div>
                        </div>
                        <RightClickMenu
                            :menuContent="row.more"
                            @action="emitAction"
                            class="regular-list-actions"
                            v-if="row.more"
                        >
                            <div class="more-icon">
                                <i
                                    :id="`menu-${row.testId}`"
                                    class="material-icons"
                                    >more_horiz</i
                                >
                            </div>
                        </RightClickMenu>
                    </RightClickMenu>
                </transition-group>
            </div>
        </transition>
        <div
            @click="loadMore"
            class="load-more"
            v-if="pagination && pagination.available"
        >
            <transition mode="out-in" name="fade">
                <div class="pagination-loading" v-if="pagination.loading">
                    <lottie-animation path="lottie/dots.json" />
                </div>
                <div v-if="!pagination.loading">
                    {{ $t('BUTTON_LOAD_MORE') }}
                </div>
            </transition>
        </div>
        <div class="list-footer" v-if="displayFooter">
            <div
                :key="`footer${index}`"
                class="footer-element"
                v-for="(footerElement, index) in footerElements"
            >
                <div v-if="footerElement.type == 'text'">
                    {{ footerElement.title }}
                    <b>{{ footerElement.value }}</b>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { timeout } from 'q'
export default {
    components: {
        RightClickMenu: () => import('@/components/utils/RightClickMenu.vue')
    },
    props: {
        footerElements: Array,
        calendarJournal: Boolean,
        popup: Boolean,
        sortable: Boolean,
        value: {
            type: Array,
            default: () => {
                return []
            }
        },
        items: {
            type: Array,
            default: () => {
                return []
            }
        },
        presenceDays: {
            type: Array,
            default: () => {
                return []
            }
        },
        header: Array,
        loading: Boolean,
        selectList: Boolean,
        defaultSort: String,
        pagination: Object,
        blockSelect: Boolean,
        placeholder: String
    },
    data() {
        return {
            selectedAll: false,
            timeout: timeout,
            currentSort: {},
            sortDirection: 'down',
            isAnySelected: false,
            draggedElement: {}
        }
    },
    computed: {
        filteredHeader() {
            return this.header.filter(h => !h.hidden)
        },
        listPlaceholder() {
            return this.placeholder
                ? this.placeholder
                : this.$t('LABEL_LIST_IS_EMPTY')
        },
        sortedItems() {
            return this.items
        },
        displayFooter() {
            if (this.footerElements) {
                return this.footerElements.length > 0
            } else {
                return false
            }
        }
    },
    methods: {
        changePresence(action) {
            if (!this.calendarJournal || !this.$refs.presence[0]) {
                return
            }
            this.$refs.presence[0][action]()
        },
        dragEnded() {
            const items = this.items.map(item => item.key)
            this.$emit('sorted', items)
        },
        checkMove(event) {
            this.draggedElement = event.draggedContext.element
        },
        display(value) {
            return value ? value : this.$t('LABEL_EMPTY')
        },
        selectInput(value) {
            this.$emit('selectInput', value)
        },
        addItem(cell, row) {
            this.$emit('addItem', { cell: cell, row: row })
        },
        checked(cell, row) {
            this.$emit('checked', { cell: cell, row: row })
        },
        confirmInput(cell, row, type) {
            this.$emit('input', cell, row, type)
        },
        loadMore() {
            if (this.pagination.loading) {
                return
            }
            this.$emit('loadMore')
        },
        toggleSort(element) {
            if (!element) {
                return
            }
            if (this.currentSort.key && this.currentSort.key == element.key) {
                this.sortDirection =
                    this.sortDirection == 'down' ? 'up' : 'down'
            } else {
                this.sortDirection = 'down'
            }
            this.currentSort = element
            this.$emit(
                'sortChanged',
                `sort=${element.key}&reverse=${this.sortDirection == 'up'}`
            )
        },
        emitAction(action) {
            this.$emit('action', action)
        },
        success() {
            clearTimeout(this.timeout)
            if (!this.$refs.list) {
                return
            }
            this.$refs.list.classList.add('success')
            this.timeout = setTimeout(() => {
                if (!this.$refs.list) {
                    return
                }
                this.$refs.list.classList.remove('success')
            }, 2000)
        },
        error() {
            clearTimeout(this.timeout)
            if (!this.$refs.list) {
                return
            }
            this.$refs.list.classList.add('error')
            this.timeout = setTimeout(() => {
                if (!this.$refs.list) {
                    return
                }
                this.$refs.list.classList.remove('error')
            }, 2000)
        },
        itemSelected(cell, row) {
            if (cell.blockSelect) {
                return
            }
            this.$emit('itemSelected', row.payload)
        },
        deselectAll() {
            this.items.forEach(item => {
                item.selected = false
            })
            this.selectedAll = false
            this.isAnySelected = false
            this.$emit('input', [])
            this.$forceUpdate()
        },
        selectAll() {
            this.items.forEach(item => {
                if (this.selectedAll) {
                    if (!item.blocked && !item.done) {
                        item.selected = true
                    }
                } else {
                    item.selected = false
                }
            })
            this.$emit('updated', selectedItems)
            this.$emit('input', selectedItems)
            this.handleCheckbox()
            this.$forceUpdate()
            const selectedItems = this.getSelectedItems()
            this.$emit('updated', selectedItems)
            this.$emit('input', selectedItems)
        },
        itemToggled() {
            this.handleCheckbox()
            const selectedItems = this.getSelectedItems()
            this.$forceUpdate()
            this.$emit('updated', selectedItems)
            this.$emit('input', selectedItems)
        },
        getSelectedItems() {
            return this.items
                .filter(item => item.selected)
                .map(item => item.payload)
        },
        convertDateToDays(date) {
            return this.$moment(date, 'YYYY-MM-DD').valueOf()
        },
        handleCheckbox() {
            this.selectedAll = this.items
                .filter(item => !item.blocked)
                .every(item => item.selected == true)
            this.isAnySelected = this.items.some(item => item.selected)
        },
        setSort() {
            if (this.defaultSort) {
                const current = this.header.find(
                    item => item.sort && item.sort.key == this.defaultSort
                )
                this.currentSort = current.sort ? current.sort : {}
            } else {
                this.header.forEach(item => {
                    if (item.sort && item.sort.key && !this.currentSort.key) {
                        this.currentSort = item.sort
                    }
                })
            }
        },
        checkItems() {
            this.items.forEach(item => {
                if (this.value.some(p => item.payload == p)) {
                    item.selected = true
                }
            })
        }
    },
    watch: {
        items() {
            this.checkItems()
            if (
                this.items.some(
                    item => !item.selected && !item.blocked && !item.done
                )
            ) {
                this.selectedAll = false
            } else if (
                !this.items.some(
                    item => !item.selected && !item.blocked && !item.done
                )
            ) {
                this.selectedAll = true
            }
            this.isAnySelected = this.items.some(item => item.selected)
            this.$forceUpdate()
        }
    },
    mounted() {
        this.setSort()
    }
}
</script>

<style lang="scss" scoped>
.regular-list {
    border: $list-border;
    max-height: 100%;
    border-radius: $small-radius;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-width: 80vw;
    box-sizing: border-box;
    margin-top: 1rem;

    &.-modal {
        margin: 0;
    }

    @media (max-width: 1300px) {
        max-width: calc(100vw - 4rem);
    }
    @media (max-width: 1000px) {
        max-width: calc(100vw - 1rem);
    }
}
.cell-content {
    display: flex;
    align-items: center;

    &.-sort {
        cursor: pointer;
        transition: $ease;

        &:hover {
            transform: translateY(0.1rem);
        }
    }
}
.sort-icon {
    margin-left: 0.2rem;
    transition: $ease;

    &.-active {
        color: $action-accent;
    }

    &.-rotated {
        transform: rotate(180deg);
    }
}
.icon {
    &.header {
        opacity: 0;
    }
}
.icon img {
    height: 2rem;
    width: 2rem;
    padding: 0.3rem;
    box-sizing: border-box;
    margin-right: 0.5rem;
}
.avatar img {
    height: 2rem;
    width: 2rem;
    border-radius: 100%;
    box-sizing: border-box;
    margin-right: 0.5rem;
}
.checkbox {
    height: 1.2rem !important;
    width: 1.2rem !important;
    margin-right: 1rem;
    border-color: $smoked !important;

    &:hover {
        border-color: $action-accent !important;
    }

    &.-checked {
        background-color: $action-accent !important;
        border-color: $action-accent !important;
    }

    &.-red {
        border-color: red !important;
        cursor: default;

        &:hover {
            transform: none;
        }
    }
}
.list-content {
    // max-height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
}
.header-avatar {
    width: 2rem;
}
.hidden {
    opacity: 0;
    pointer-events: none;
}
.list-item {
    display: flex;
    margin-right: 10px;
    transition: $ease;
}
.icons {
    display: flex;
    align-items: center;
}
.icon-wrap {
    position: relative;
    display: flex;
    justify-content: center;
}
.icon-wrap span {
    margin-top: -1rem;
    background: $dark-accent;
    position: absolute;
    pointer-events: none;
    transition: $ease;
    opacity: 0;
    border-radius: 0.2rem;
    padding: 0.2rem;
    width: 10rem;
    text-align: center;
    font-size: 0.8rem;
    z-index: $highest;
    color: $light-accent;
    text-overflow: normal !important;
    white-space: normal !important;
}
.icon-wrap:hover span {
    opacity: 1;
}
.icon-wrap img {
    height: 1.5rem;
    width: 1.5rem;
    margin-right: 1rem;
}
.list-footer {
    border-top: solid 0.1rem $border-accent;
    display: flex;
    justify-content: flex-end;
    padding: 0.5rem 1rem;
}
.footer-element {
    margin-left: 1rem;
}
.load-more {
    display: flex;
    justify-content: center;
    border-top: solid 0.1rem $border-accent;
    padding: 0.5rem 1rem;
}
.load-more div {
    cursor: pointer;
    transition: $ease;
    user-select: none;

    &:hover {
        transform: translateY(0.1rem);
    }
}
.hour-range {
    display: flex;
    align-items: center;
}
.hour-range-hour {
    cursor: pointer;
    transition: $ease;

    &:hover &:first-of-type {
        margin-right: 0.5rem;
    }
    &:last-of-type {
        margin-left: 0.5rem;
    }
}
.more-icon i {
    color: $smoked;
}
.checkbox-blocked i {
    color: $accent-apple;
}
.pagination-loading {
    height: 5rem;
}
.success {
    animation: success 2s ease;
}
.error {
    animation: error 0.8s ease;
}
@keyframes success {
    0% {
        border-color: $border-accent;
    }
    50% {
        border-color: $accent-apple;
    }
    100% {
        border-color: $border-accent;
    }
}
@keyframes error {
    0% {
        border-color: $border-accent;
    }
    50% {
        border-color: $accent-red;
    }
    100% {
        border-color: $border-accent;
    }
}
.regular-list-cell-sub-text {
    font-size: 0.7rem;
    color: $action-accent;
    margin-top: 0.2rem;
    letter-spacing: 0.08rem;
}
.regular-list-row {
    min-height: 2.8rem;
    font-size: 1rem;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    cursor: pointer;
    transition: $ease;

    &:not(:last-of-type) {
        border-bottom: $list-border;
    }

    &:hover {
        background: rgb(65, 65, 65);
    }
    &.-selected {
        background: $action-accent;
    }
    &.-ghost {
        opacity: 0.5;
    }
    &.-block-select {
        cursor: default;

        &:hover {
            background: transparent;
        }
    }

    &.-placeholder {
        padding: 4rem;
        justify-content: center;
        cursor: auto;

        &:hover {
            background: $background;
        }
    }
}
.list-header {
    display: flex;
    align-items: center;
    padding: 0 1rem;
    border-bottom: $list-border;
    user-select: none;
}
.regular-list-cell {
    display: flex;
    align-items: center;
    padding: 0.5rem 1rem;
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;

    &.-wrap {
        white-space: nowrap;
    }

    &.-important {
        font-family: $input-family;
        color: red;
    }

    &.-header {
        color: $smoked;
        font-family: $input-family;
        font-size: 0.9rem;
    }

    &.-sort {
        cursor: pointer;
    }

    &.-hidden {
        padding: 0;
    }

    &.-red {
        font-family: $input-family;
        color: $accent-red;
    }
    &.-blue {
        font-family: $input-family;
        color: $accent-blue;
    }
    &.green {
        font-family: $input-family;
        color: $accent-apple;
    }
    &.orange {
        font-family: $input-family;
        color: $accent-orange;
    }
}
</style>
